import React from "react";

export default ({ color, size }) => (
  <svg width={size || 24} height={size || 24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>transfer-right</title>
    <path fill={color} d="M3,8H5V16H3V8M7,8H9V16H7V8M11,8H13V16H11V8M15,19.25V4.75L22.25,12L15,19.25Z" />
  </svg>
);
